import React from "react";
import Form from "react-bootstrap/Form";
import { Col, Row } from "react-bootstrap";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleIcon from "@mui/icons-material/AddCircle";

const emptyEdu = {
  institutename: "",
  startdate: "",
  enddate: "",
  major: "",
  qualification: "",
  typeofstudy: "",
  degreestatus: "",
};

const FormalEducation = ({ newdata, setNewdata }) => {
  // Use newdata.formaleducation as source of truth
  const formaleducation = newdata.formaleducation || [emptyEdu];

  // Handle input changes
  const handelvalues = (e, index) => {
    const { name, value } = e.target;
    const updated = [...formaleducation];
    updated[index] = { ...updated[index], [name]: value };
    setNewdata(prev => ({ ...prev, formaleducation: updated }));
  };

  // Add new education row
  const AddmoreFields = () => {
    setNewdata(prev => ({
      ...prev,
      formaleducation: [...formaleducation, emptyEdu],
    }));
  };

  // Remove education row
  const handleRemoveClick = (index) => {
    setNewdata(prev => ({
      ...prev,
      formaleducation: formaleducation.filter((_, i) => i !== index),
    }));
  };

  // Optional: restrict institute name input to alphabets only
  const handleKeyPress = (event) => {
    const charCode = event.charCode;
    if (!(charCode >= 65 && charCode <= 90) && !(charCode >= 97 && charCode <= 122)) {
      event.preventDefault();
    }
  };

  return (
    <div className="px-2">
      {formaleducation.map((edu, index) => (
        <div key={index}>
          <Row>
            <Col md={4}>
              <Form.Label className="custm-lble">Institute Name</Form.Label>
              <Form.Control
                placeholder="Institute Name"
                type="text"
                name="institutename"
                value={edu.institutename}
                onKeyPress={handleKeyPress}
                onChange={(e) => handelvalues(e, index)}
              />
            </Col>
            <Col md={4}>
              <Form.Label className="custm-lble">Start Date</Form.Label>
              <Form.Control
                placeholder="Start Date"
                type="text"
                name="startdate"
                value={edu.startdate}
                onChange={(e) => handelvalues(e, index)}
              />
            </Col>
            <Col md={4}>
              <Form.Label className="custm-lble">End Date</Form.Label>
              <Form.Control
                placeholder="End Date"
                type="text"
                name="enddate"
                value={edu.enddate}
                onChange={(e) => handelvalues(e, index)}
              />
            </Col>
          </Row>

          <Row>
            <Col md={4}>
              <Form.Label className="custm-lble">Major</Form.Label>
              <Form.Control
                placeholder="Major"
                type="text"
                name="major"
                value={edu.major}
                onChange={(e) => handelvalues(e, index)}
              />
            </Col>
            <Col md={4}>
              <Form.Label className="custm-lble">Qualification</Form.Label>
              <Form.Control
                placeholder="Qualification"
                type="text"
                name="qualification"
                value={edu.qualification}
                onChange={(e) => handelvalues(e, index)}
              />
            </Col>
            <Col md={4}>
              <Form.Label className="custm-lble">Type of Study</Form.Label>
              <Form.Control
                placeholder="Type of Study"
                type="text"
                name="typeofstudy"
                value={edu.typeofstudy}
                onChange={(e) => handelvalues(e, index)}
              />
            </Col>
          </Row>

          <Row>
            <Col md={4}>
              <Form.Label className="custm-lble">Degree Status</Form.Label>
              <Form.Control
                placeholder="Degree Status"
                type="text"
                name="degreestatus"
                value={edu.degreestatus}
                onChange={(e) => handelvalues(e, index)}
              />
            </Col>
          </Row>

          {index !== 0 && (
            <div
              className="d-flex justify-content-end cursor_P mb-2"
              onClick={() => handleRemoveClick(index)}
            >
              <DeleteIcon className="color-red" />
              <p className="color-remove-red mb-0 ms-1">Remove</p>
            </div>
          )}

          <hr className="mb-3" />
        </div>
      ))}

      <div className="mb-3" onClick={AddmoreFields}>
        <p className="color-text cursor_P">
          <AddCircleIcon style={{ fontSize: "large" }} /> Add More
        </p>
      </div>
    </div>
  );
};

export default FormalEducation;
